<style scoped lang="less">
#editor-container {
    border: 6px solid #f2f2f2;
    width: 350px;
    height: 600px;
}
#toolbar-container {
    max-width: 800px;
}
</style>

<template>
    <el-dialog destroy-on-close fullscreen :visible.sync="show" title="添加/修改" :close-on-press-escape="false">
        <el-form size="mini" label-width="100px" v-if="model">
            <el-form-item label="标签">
                <el-autocomplete v-model="model.tag" clearable :fetch-suggestions="querySelectTag" @select="handleSelectTag"></el-autocomplete>
            </el-form-item>
            <el-form-item label="标题">
                <el-input v-model="model.title"></el-input>
            </el-form-item>
            <!-- <el-form-item label="封面">
                <el-input v-model="model.cover"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="作者">
                <el-input v-model="model.author"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="日期">
                <el-date-picker v-model="model.date" type="date"></el-date-picker>
            </el-form-item> -->
            <el-form-item label="备注">
                <el-input v-model="model.remarks"></el-input>
            </el-form-item>
            <el-form-item label="内容">
                <div id="toolbar-container"></div>
                <div id="editor-container"></div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.stop="show = false" plain>取 消</el-button>
            <el-button type="primary" @click.stop="save" :loading="loadingSave">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { HttpClient } from "../../util/http.js";
import { msgError, msgSuccess } from "../../util/toast";
const { createEditor, createToolbar } = window.wangEditor;

export default {
    components: {},
    data() {
        return {
            loadingSave: false,
            show: false,
            model: null,
        };
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
        handleSelectTag(item) {
            this.model.tag = item.value;
        },
        querySelectTag(queryString, cb) {
            cb([{ value: "精选" }]);
        },
        addOrEdit(item) {
            this.show = true;
            this.model = this.deepCopy({
                contentHtml: "",
                ...item,
            });
            this.$nextTick(() => {
                this.initEditor();
            });
        },
        initEditor() {
            const editorConfig = {};
            editorConfig.placeholder = "请输入内容";
            editorConfig.onChange = (editor) => {
                this.model["contentHtml"] = editor.getHtml();
                this.model["contentText"] = editor.getText();
            };
            const editor = createEditor({
                html: this.model.contentHtml,
                selector: "#editor-container",
                config: editorConfig,
                mode: "default",
            });
            const toolbarConfig = {
                excludeKeys: [
                    "fullScreen",
                    "group-video",
                    "insertLink",
                    "insertTable",
                    "uploadImage",
                ],
            };
            const toolbar = createToolbar({
                editor: editor,
                selector: "#toolbar-container",
                config: toolbarConfig,
                mode: "default",
            });
        },
        async save() {
            this.loadingSave = true;
            await HttpClient.put("/restful", {
                model: "News",
                cond: this.model._id,
                updates: this.model,
            });
            msgSuccess();
            this.show = false;
            this.loadingSave = false;
            this.$emit("fetch-data");
        },
        //深拷贝
        deepCopy(obj) {
            if (obj == null) {
                return null;
            }
            if (Array.isArray(obj)) {
                //如果是数组
                const myArray = [];
                for (let i = 0; i < obj.length; i++) {
                    myArray.push(this.deepCopy(obj[i]));
                }
                return myArray;
            } else if (typeof obj == "object") {
                //如果是对象
                const myObject = {};
                for (let key in obj) {
                    myObject[key] = this.deepCopy(obj[key]);
                }
                return myObject;
            }
            return obj;
        },
    },
};
</script>

        